export const regions = ['US', 'CA', 'EU'];